module.exports = __webpack_public_path__ + "d712d35b7bab2fb39dfa2cdb21b0ebba.jpg"


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/images/labels/products/golf-channel-hat.jpg
 ** module id = 452
 ** module chunks = 0
 **/